/**
 * 判断浏览器是否支持html5本地存储
 */
export const localStorageSupport = () => {
  return (('localStorage' in window) && window['localStorage'] !== null)
}
/**
 * 存储一个新的localStorage记录
 * @param   {String}    name    key值
 * @param   {String}    content 内容
 */
export const setLocalStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

/**
 * 根据key值获取localStorage的一条记录
 * @param   {String}    name    key值
 */
export const getLocalStore = name => {
  if (!name) return
  return window.sessionStorage.getItem(name)
}

/**
 * 根据key值删除localStorage的一条记录
 * @param   {String}    name    key值
 */
export const removeLocalStore = name => {
  if (!name) return
  window.sessionStorage.removeItem(name)
}


export const setLocalStoreEver = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 根据key值获取localStorage的一条记录
 * @param   {String}    name    key值
 */
export const getLocalStoreEver = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}